import { CookieKeys, Cookies } from "./cookieKey";

/** 服务热线 **/
export function getServicePhone(type) {
  try {
    if (type) {
      return "400-900-6616";
    } else {
      return "400-688-2000";
    }
  } catch (e) {
    return "400-900-6616";
  }
}

/**
 * 判断数据是否为空
 * @param {*} str 数据
 * @returns boolean
 */
export function isValEmpty(str) {
  return (
    str === undefined ||
    str === "undefined" ||
    str === null ||
    str === "null" ||
    str.length === 0 ||
    JSON.stringify(str) === "{}"
  );
}

export function getQuery(fullPath) {
  const url = fullPath || window.location.href;
  const queryObj = {};
  if (!url.includes("?")) {
    return {};
  }
  url
    .split("?")[1]
    .split("&")
    .map((i) => (queryObj[i.split("=")[0]] = i.split("=")[1]));
  return queryObj;
}
export function isCapture() {
  return getQuery().type === "capture";
}
// 清除cookies
export function clearCookies() {
  try {
    Cookies.remove(`${Cookies.get(CookieKeys.qlm_username)}${Cookies.get(CookieKeys.qlm_password)}`, "", {
      path: "/",
      domain: ".qianlima.com",
    });
  } catch (e) {
    console.error("clear Cookies error: ", e);
  }
  Cookies.remove(CookieKeys.qlm_username, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.qlm_password, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.xAuthToken, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.userInfo, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.userAppMenu, {
    path: "/",
    domain: ".qianlima.com",
  });
  Cookies.remove(CookieKeys.userLeftMenuClick, {
    path: "/",
    domain: ".qianlima.com",
  });
}

// 退出登录
export function logOutOfLogin() {
  // 清除cookies
  clearCookies();
  // 刷新当前页
  window.location.href = "/";
}
/** 深拷贝 **/
export function deepClone(source) {
  if (!source) return;
  const targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
  for (let keys in source) {
    // 遍历目标
    if (Object.hasOwnProperty.call(source, keys)) {
      if (source[keys] && typeof source[keys] === "object") {
        // 如果值是对象，就递归一下
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else {
        // 如果不是，就直接赋值
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}

/** 返回且或关系文案 **/
export function andOrLabel(keywordsAndOr) {
  if (keywordsAndOr === "|") {
    return "包含任意关键词";
  }
  if (keywordsAndOr === "&") {
    return "包含全部关键词";
  }
  return "包含任意关键词";
}

//时间戳转换年月日格式
export function getData(n) {
  let now = new Date(n),
    y = now.getFullYear(),
    m = now.getMonth() + 1,
    d = now.getDate();
  return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
}

/**
 * 时间显示效果显示
 * @param {String} time 需要转换的时间
 * @param {String} option 格式 {y}-{m}-{d} {h}:{i}:{s}
 * @return: {String} 转换完成的时间
 */
export function conversionTime(time) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();
  if (d.toDateString() === new Date().toDateString()) {
    const diff = (now - d) / 1000;
    if (diff < 60) {
      return "1分钟前";
    } else if (diff < 3600) {
      // less 1 hour
      return Math.floor(diff / 60) + "分钟前";
    } else {
      return Math.floor(diff / 3600) + "小时前";
    }
  } else if (d < new Date()) {
    return getData(time);
  }
}

/**
 * 时间转换
 * @param {number} time 需要转换的时间
 * @param {String} cFormat 格式 {y}-{m}-{d} {h}:{i}:{s}
 * @return: {String} timeStr 转换完成的时间
 */
export function DateFormat(time, cFormat) {
  if (arguments.length === 0) {
    return "-";
  }
  if (time === null) {
    return "-";
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (time === "") {
    date = new Date();
  } else if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    if (String(time).indexOf("T") > -1) {
      time = time.replace(/T/g, " ").replace(/\..*/g, "");
    }
    if (String(time).indexOf("-") > -1 && String(time).indexOf("T") === -1) {
      time = time.replace(/-/g, "/");
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return timeStr;
}

//金额转换元或万元
export function formatNumberToMoney(num) {
  num = Number(num);
  if (num === 0) {
    return num + "元";
  } else if (num > 1 && num < 10000) {
    return num + "元";
  } else if (Object.is(num, NaN)) {
    return "-";
  } else {
    num = parseInt(num / 100);
    return num / 100 + "万元";
  }
}

// 获取根路径
export const getBasePath = () => {
  if (
    ["home-test.qianlima.com", "home.qianlima.com"].includes(window.location.hostname) ||
    process.env.NODE_ENV === "development"
  ) {
    return "";
  } else {
    const path = window.location.pathname; // 获取当前页面的路径：'/qlmbidding1_pc/search'
    const parts = path.split("/"); // 拆分路径，得到各级路径的数组：['', 'qlmbidding1_pc', 'search', '']
    const result = parts[1]; // 获取根目录下的一级路径，即数组中的第二项
    return "/" + result;
  }
};

// 获取登录状态
export const getLoginStatus = () => {
  return (
    (Cookies.get(CookieKeys.qlm_username) && Cookies.get(CookieKeys.qlm_password)) || Cookies.get(CookieKeys.userInfo)
  );
};

// 是否爬虫访问
export const isSpider = () => {
  const UA = navigator.userAgent;
  const isSpider = UA.toLowerCase().indexOf("spider") !== -1;
  return isSpider;
};

// 是否是完整链接
export const getIsCompleteHref = (href) => {
  const hrefRegex = new RegExp("^(http:|https:|ftp:)?(//.+)", "i");
  return hrefRegex.test(href);
};

// 拼接动态链接 根路径是动态
export const formatTrendsLink = (url) => {
  let formatUrl = getIsCompleteHref(url) ? url : getBasePath() + url;
  return formatUrl;
};
